export default __webpack_public_path__ + "9983dbe6cc6abb0de79cf61be254f5ec.jpg";